'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PickerMixin = require('./PickerMixin');

var _PickerMixin2 = _interopRequireDefault(_PickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Picker = function (_React$Component) {
    (0, _inherits3['default'])(Picker, _React$Component);

    function Picker(props) {
        (0, _classCallCheck3['default'])(this, Picker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

        _this.scrollHanders = function () {
            var scrollY = -1;
            var lastY = 0;
            var startY = 0;
            var scrollDisabled = false;
            var isMoving = false;
            var setTransform = function setTransform(nodeStyle, value) {
                nodeStyle.transform = value;
                nodeStyle.webkitTransform = value;
            };
            var setTransition = function setTransition(nodeStyle, value) {
                nodeStyle.transition = value;
                nodeStyle.webkitTransition = value;
            };
            var scrollTo = function scrollTo(x, y) {
                var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .3;

                if (scrollY !== y) {
                    scrollY = y;
                    if (time && !_this.props.noAnimate) {
                        setTransition(_this.contentRef.style, 'cubic-bezier(0,0,0.2,1.15) ' + time + 's');
                    }
                    setTransform(_this.contentRef.style, 'translate3d(0,' + -y + 'px,0)');
                    setTimeout(function () {
                        _this.scrollingComplete();
                        if (_this.contentRef) {
                            setTransition(_this.contentRef.style, '');
                        }
                    }, +time * 1000);
                }
            };
            var Velocity = function () {
                var minInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
                var maxInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

                var _time = 0;
                var _y = 0;
                var _velocity = 0;
                var recorder = {
                    record: function record(y) {
                        var now = +new Date();
                        _velocity = (y - _y) / (now - _time);
                        if (now - _time >= minInterval) {
                            _velocity = now - _time <= maxInterval ? _velocity : 0;
                            _y = y;
                            _time = now;
                        }
                    },
                    getVelocity: function getVelocity(y) {
                        if (y !== _y) {
                            recorder.record(y);
                        }
                        return _velocity;
                    }
                };
                return recorder;
            }();
            var onFinish = function onFinish() {
                isMoving = false;
                var targetY = scrollY;
                var height = (_this.props.children.length - 1) * _this.itemHeight;
                var time = .3;
                var velocity = Velocity.getVelocity(targetY) * 4;
                if (velocity) {
                    targetY = velocity * 40 + targetY;
                    time = Math.abs(velocity) * .1;
                }
                if (targetY % _this.itemHeight !== 0) {
                    targetY = Math.round(targetY / _this.itemHeight) * _this.itemHeight;
                }
                if (targetY < 0) {
                    targetY = 0;
                } else if (targetY > height) {
                    targetY = height;
                }
                scrollTo(0, targetY, time < .3 ? .3 : time);
                _this.onScrollChange();
            };
            var onStart = function onStart(y) {
                if (scrollDisabled) {
                    return;
                }
                isMoving = true;
                startY = y;
                lastY = scrollY;
            };
            var onMove = function onMove(y) {
                if (scrollDisabled || !isMoving) {
                    return;
                }
                scrollY = lastY - y + startY;
                Velocity.record(scrollY);
                _this.onScrollChange();
                setTransform(_this.contentRef.style, 'translate3d(0,' + -scrollY + 'px,0)');
            };
            return {
                touchstart: function touchstart(evt) {
                    return onStart(evt.touches[0].screenY);
                },
                mousedown: function mousedown(evt) {
                    return onStart(evt.screenY);
                },
                touchmove: function touchmove(evt) {
                    evt.preventDefault();
                    onMove(evt.touches[0].screenY);
                },
                mousemove: function mousemove(evt) {
                    evt.preventDefault();
                    onMove(evt.screenY);
                },
                touchend: function touchend() {
                    return onFinish();
                },
                touchcancel: function touchcancel() {
                    return onFinish();
                },
                mouseup: function mouseup() {
                    return onFinish();
                },
                getValue: function getValue() {
                    return scrollY;
                },
                scrollTo: scrollTo,
                setDisabled: function setDisabled() {
                    var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    scrollDisabled = disabled;
                }
            };
        }();
        _this.scrollTo = function (top) {
            _this.scrollHanders.scrollTo(0, top);
        };
        _this.scrollToWithoutAnimation = function (top) {
            _this.scrollHanders.scrollTo(0, top, 0);
        };
        _this.fireValueChange = function (selectedValue) {
            if (selectedValue !== _this.state.selectedValue) {
                if (!('selectedValue' in _this.props)) {
                    _this.setState({
                        selectedValue: selectedValue
                    });
                }
                if (_this.props.onValueChange) {
                    _this.props.onValueChange(selectedValue);
                }
            }
        };
        _this.onScrollChange = function () {
            var top = _this.scrollHanders.getValue();
            if (top >= 0) {
                var children = _react2['default'].Children.toArray(_this.props.children);
                var index = _this.props.coumputeChildIndex(top, _this.itemHeight, children.length);
                if (_this.scrollValue !== index) {
                    _this.scrollValue = index;
                    var child = children[index];
                    if (child && _this.props.onScrollChange) {
                        _this.props.onScrollChange(child.props.value);
                    } else if (!child && console.warn) {
                        console.warn('child not found', children, index);
                    }
                }
            }
        };
        _this.scrollingComplete = function () {
            var top = _this.scrollHanders.getValue();
            if (top >= 0) {
                _this.props.doScrollingComplete(top, _this.itemHeight, _this.fireValueChange);
            }
        };
        var selectedValueState = void 0;
        var _this$props = _this.props,
            selectedValue = _this$props.selectedValue,
            defaultSelectedValue = _this$props.defaultSelectedValue;

        if (selectedValue !== undefined) {
            selectedValueState = selectedValue;
        } else if (defaultSelectedValue !== undefined) {
            selectedValueState = defaultSelectedValue;
        } else {
            var children = _react2['default'].Children.toArray(_this.props.children);
            selectedValueState = children && children[0] && children[0].props.value;
        }
        _this.state = {
            selectedValue: selectedValueState
        };
        return _this;
    }

    (0, _createClass3['default'])(Picker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var contentRef = this.contentRef,
                indicatorRef = this.indicatorRef,
                maskRef = this.maskRef,
                rootRef = this.rootRef;

            var rootHeight = rootRef.getBoundingClientRect().height;
            // https://github.com/react-component/m-picker/issues/18
            var itemHeight = this.itemHeight = indicatorRef.getBoundingClientRect().height;
            var num = Math.floor(rootHeight / itemHeight);
            if (num % 2 === 0) {
                num--;
            }
            num--;
            num /= 2;
            contentRef.style.padding = itemHeight * num + 'px 0';
            indicatorRef.style.top = itemHeight * num + 'px';
            maskRef.style.backgroundSize = '100% ' + itemHeight * num + 'px';
            this.scrollHanders.setDisabled(this.props.disabled);
            this.props.select(this.state.selectedValue, this.itemHeight, this.scrollTo);
            var passiveSupported = this.passiveSupported();
            var willPreventDefault = passiveSupported ? { passive: false } : false;
            var willNotPreventDefault = passiveSupported ? { passive: true } : false;
            Object.keys(this.scrollHanders).forEach(function (key) {
                if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
                    var pd = key.indexOf('move') >= 0 ? willPreventDefault : willNotPreventDefault;
                    rootRef.addEventListener(key, _this2.scrollHanders[key], pd);
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this3 = this;

            Object.keys(this.scrollHanders).forEach(function (key) {
                if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
                    _this3.rootRef.removeEventListener(key, _this3.scrollHanders[key]);
                }
            });
        }
    }, {
        key: 'passiveSupported',
        value: function passiveSupported() {
            var passiveSupported = false;
            try {
                var options = Object.defineProperty({}, 'passive', {
                    get: function get() {
                        passiveSupported = true;
                    }
                });
                window.addEventListener('test', null, options);
            } catch (err) {}
            return passiveSupported;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this4 = this;

            if ('selectedValue' in nextProps) {
                if (this.state.selectedValue !== nextProps.selectedValue) {
                    this.setState({
                        selectedValue: nextProps.selectedValue
                    }, function () {
                        _this4.props.select(nextProps.selectedValue, _this4.itemHeight, nextProps.noAnimate ? _this4.scrollToWithoutAnimation : _this4.scrollTo);
                    });
                }
            }
            this.scrollHanders.setDisabled(nextProps.disabled);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return this.state.selectedValue !== nextState.selectedValue || this.props.children !== nextProps.children;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.props.select(this.state.selectedValue, this.itemHeight, this.scrollToWithoutAnimation);
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            if ('selectedValue' in this.props) {
                return this.props.selectedValue;
            }
            var children = _react2['default'].Children.toArray(this.props.children);
            return children && children[0] && children[0].props.value;
        }
    }, {
        key: 'render',
        value: function render() {
            var _pickerCls,
                _this5 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                itemStyle = props.itemStyle,
                indicatorStyle = props.indicatorStyle,
                _props$indicatorClass = props.indicatorClassName,
                indicatorClassName = _props$indicatorClass === undefined ? '' : _props$indicatorClass,
                children = props.children;
            var selectedValue = this.state.selectedValue;

            var itemClassName = prefixCls + '-item';
            var selectedItemClassName = itemClassName + ' ' + prefixCls + '-item-selected';
            var map = function map(item) {
                var _item$props = item.props,
                    _item$props$className = _item$props.className,
                    className = _item$props$className === undefined ? '' : _item$props$className,
                    style = _item$props.style,
                    value = _item$props.value;

                return _react2['default'].createElement(
                    'div',
                    { style: (0, _extends3['default'])({}, itemStyle, style), className: (selectedValue === value ? selectedItemClassName : itemClassName) + ' ' + className, key: value },
                    item.children || item.props.children
                );
            };
            // compatibility for preact
            var items = _react2['default'].Children ? _react2['default'].Children.map(children, map) : [].concat(children).map(map);
            var pickerCls = (_pickerCls = {}, (0, _defineProperty3['default'])(_pickerCls, props.className, !!props.className), (0, _defineProperty3['default'])(_pickerCls, prefixCls, true), _pickerCls);
            return _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(pickerCls), ref: function ref(el) {
                        return _this5.rootRef = el;
                    }, style: this.props.style },
                _react2['default'].createElement('div', { className: prefixCls + '-mask', ref: function ref(el) {
                        return _this5.maskRef = el;
                    } }),
                _react2['default'].createElement('div', { className: prefixCls + '-indicator ' + indicatorClassName, ref: function ref(el) {
                        return _this5.indicatorRef = el;
                    }, style: indicatorStyle }),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-content', ref: function ref(el) {
                            return _this5.contentRef = el;
                        } },
                    items
                )
            );
        }
    }]);
    return Picker;
}(_react2['default'].Component);

Picker.defaultProps = {
    prefixCls: 'rmc-picker'
};
exports['default'] = (0, _PickerMixin2['default'])(Picker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rmc-picker/lib/Picker.js
// module id = 1074
// module chunks = 0